import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from '../components/Sidebar';
import './Dashboard.css';

const DEFAULT_ITEMS = [
  'مكعبات 15×15',
  'مكعبات 10×10',
  'مفتاح 17',
  'مفتاح 14',
  'مفتاح 13',
  'الانكيه 17',
  'الانكيه 14',
  'الانكيه 13',
  'بالتة Slump',
  'عامود دمج Slump',
  'مخروط Slump',
  'بالتة Flow',
  'عامود دمج Flow',
  'مخروط Flow',
  'أجهزة ثرمو',
  'بطاريات ثرمو',
  'شاحن بطاريات ثرمو',
  'ترمومتر',
  'بارويطه',
  'ورق فلو اب',
  'جاروف',
  'مسطرين',
  'بروة',
  'متر'
];

const StationInventory = () => {
  const { station } = useParams();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editValues, setEditValues] = useState({});
  const { user } = useAuth();

  console.log("DEBUG:", { user, role: user?.role, canApprove: user && ["admin", "engineer", "supervisor", "senior"].includes(user.role) });
  const canApprove = user && ['admin', 'engineer', 'supervisor', 'senior'].includes(user.role);
  const decodedStation = decodeURIComponent(station);

  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/inventory/station/${encodeURIComponent(decodedStation)}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      
      const mergedInventory = DEFAULT_ITEMS.map((itemName, index) => {
        const existingItem = data.find(item => item.itemName === itemName);
        return {
          itemName,
          quantity: existingItem?.quantity || 0,
          pendingChange: existingItem?.pendingChange,
          pendingBy: existingItem?.pendingBy,
          approvedBy: existingItem?.approvedBy,
          _id: existingItem?._id,
          index: index + 1
        };
      });
      
      setInventory(mergedInventory);
      
      // Initialize edit values
      const initialEditValues = {};
      mergedInventory.forEach((item, idx) => {
        initialEditValues[idx] = item.quantity > 0 ? item.quantity.toString() : '';
      });
      setEditValues(initialEditValues);
    } catch (error) {
      console.error('Error fetching inventory:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (idx, value) => {
    setEditValues(prev => ({
      ...prev,
      [idx]: value
    }));
  };

  const handleUpdateQuantity = async (item, idx) => {
    try {
      const token = localStorage.getItem('token');
      const newValue = editValues[idx];
      const quantity = parseInt(newValue);

      if (newValue === '' || isNaN(quantity) || quantity < 0) {
        alert('الرجاء إدخال رقم صحيح أو اترك الحقل فارغاً');
        return;
      }

      // إذا المستخدم Admin/Senior/Supervisor/Engineer → تنفيذ مباشر
      if (canApprove) {
        if (item._id) {
          // تحديث مباشر
          const response = await fetch(`/api/inventory/direct-update/${item._id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ newQuantity: quantity })
          });

          if (response.ok) {
            alert('تم تحديث الكمية بنجاح');
          }
        } else {
          // إضافة مباشرة
          const response = await fetch('/api/inventory/direct-add', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
              station: decodedStation,
              itemName: item.itemName,
              quantity: quantity
            })
          });

          if (response.ok) {
            alert('تم إضافة الصنف بنجاح');
          }
        }
      } else {
        // طلب موافقة للمستخدمين العاديين
        if (item._id) {
          const response = await fetch(`/api/inventory/request/${item._id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ newQuantity: quantity })
          });

          if (response.ok) {
            alert('تم إرسال طلب التعديل للموافقة');
          }
        } else {
          const response = await fetch('/api/inventory/add', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
              station: decodedStation,
              itemName: item.itemName,
              quantity: quantity
            })
          });

          if (response.ok) {
            alert('تم إرسال طلب الإضافة للموافقة');
          }
        }
      }

      fetchInventory();
    } catch (error) {
      console.error('Error updating:', error);
      alert('خطأ في التحديث');
    }
  };

  const handleApprove = async (itemId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/inventory/approve/${itemId}`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        alert('تم الموافقة على التعديل');
        fetchInventory();
      }
    } catch (error) {
      console.error('Error approving:', error);
      alert('خطأ في الموافقة');
    }
  };

  const handleReject = async (itemId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/inventory/reject/${itemId}`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        alert('تم رفض التعديل');
        fetchInventory();
      }
    } catch (error) {
      console.error('Error rejecting:', error);
      alert('خطأ في الرفض');
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  if (loading) {
    return (
      <div className="dashboard-layout">
        <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div className="dashboard-content">
          <div style={{ textAlign: 'center', padding: '50px', fontSize: '20px', color: '#666' }}>
            جاري تحميل بيانات المخزون...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>☰</button>
          <h1>📦 مخزون {decodedStation}</h1>
        </div>

        <div className="dashboard-main" style={{ padding: '20px' }}>
          <button
            onClick={() => navigate('/inventory')}
            style={{
              padding: '12px 24px',
              background: 'linear-gradient(135deg, #6c757d 0%, #5a6268 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              marginBottom: '25px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
            }}
          >
            ← العودة للمحطات
          </button>

          <div style={{
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
            overflow: 'hidden'
          }}>
            <div style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              padding: '25px',
              color: 'white',
              textAlign: 'center'
            }}>
              <h2 style={{ margin: 0, fontSize: '26px', fontWeight: 'bold' }}>
                جدول المخزون - {decodedStation}
              </h2>
              <p style={{ margin: '10px 0 0 0', fontSize: '15px', opacity: 0.9 }}>
                إدارة المواد والمعدات
              </p>
            </div>

            <div style={{ overflowX: 'auto' }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse'
              }}>
                <thead>
                  <tr style={{ 
                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                    borderBottom: '3px solid #dee2e6'
                  }}>
                    <th style={{ 
                      padding: '18px', 
                      textAlign: 'center',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      color: '#495057',
                      width: '80px'
                    }}>
                      #
                    </th>
                    <th style={{ 
                      padding: '18px', 
                      textAlign: 'right',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      color: '#495057'
                    }}>
                      الصنف
                    </th>
                    <th style={{ 
                      padding: '18px', 
                      textAlign: 'center',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      color: '#495057',
                      width: '150px'
                    }}>
                      العدد
                    </th>
                    <th style={{ 
                      padding: '18px', 
                      textAlign: 'center',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      color: '#495057',
                      width: '180px'
                    }}>
                      الحالة
                    </th>
                    <th style={{ 
                      padding: '18px', 
                      textAlign: 'center',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      color: '#495057',
                      width: '250px'
                    }}>
                      إجراءات
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {inventory.map((item, idx) => {
                    const hasPending = item.pendingChange !== null && item.pendingChange !== undefined;
                    const hasBeenApproved = item.approvedBy !== null && item.approvedBy !== undefined;

                    return (
                      <tr 
                        key={idx}
                        style={{ 
                          borderBottom: '1px solid #dee2e6',
                          transition: 'background 0.2s',
                          background: idx % 2 === 0 ? '#ffffff' : '#f8f9fa'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#e3f2fd'}
                        onMouseLeave={(e) => e.currentTarget.style.background = idx % 2 === 0 ? '#ffffff' : '#f8f9fa'}
                      >
                        <td style={{ 
                          padding: '15px', 
                          textAlign: 'center',
                          fontSize: '16px',
                          fontWeight: 'bold',
                          color: '#6c757d'
                        }}>
                          {item.index}
                        </td>
                        <td style={{ 
                          padding: '15px', 
                          textAlign: 'right',
                          fontSize: '16px',
                          fontWeight: '500',
                          color: '#212529'
                        }}>
                          {item.itemName}
                        </td>
                        <td style={{ 
                          padding: '15px', 
                          textAlign: 'center'
                        }}>
                          {hasPending ? (
                            <div style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              gap: '5px'
                            }}>
                              <span style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: item.quantity === 0 ? '#dc3545' : '#28a745'
                              }}>
                                {item.quantity === 0 ? '⚠️ ناقص' : item.quantity}
                              </span>
                              <div style={{ 
                                fontSize: '13px', 
                                color: '#856404', 
                                fontWeight: '500',
                                background: '#fff3cd',
                                padding: '3px 8px',
                                borderRadius: '5px'
                              }}>
                                معلق: {item.pendingChange === 0 ? 'ناقص' : item.pendingChange}
                              </div>
                            </div>
                          ) : (
                            <input
                              type="number"
                              min="0"
                              value={editValues[idx] || ''}
                              onChange={(e) => handleInputChange(idx, e.target.value)}
                              onBlur={() => {
                                if (editValues[idx] !== item.quantity.toString() && editValues[idx] !== '') {
                                  handleUpdateQuantity(item, idx);
                                }
                              }}
                              onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                  e.target.blur();
                                }
                              }}
                              placeholder={item.quantity === 0 ? 'ناقص' : ''}
                              style={{
                                width: '100px',
                                padding: '10px',
                                border: '2px solid #007bff',
                                borderRadius: '8px',
                                textAlign: 'center',
                                fontSize: '18px',
                                fontWeight: 'bold',
                                outline: 'none',
                                background: editValues[idx] === '' || editValues[idx] === '0' ? '#fff3cd' : '#fff'
                              }}
                            />
                          )}
                        </td>
                        <td style={{ 
                          padding: '15px', 
                          textAlign: 'center'
                        }}>
                          {hasPending ? (
                            <div style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '8px 16px',
                              background: 'linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)',
                              borderRadius: '8px',
                              fontSize: '14px',
                              fontWeight: 'bold',
                              color: '#856404',
                              boxShadow: '0 2px 8px rgba(255,193,7,0.3)'
                            }}>
                              <span>⏳</span>
                              <span>تحت المراجعة</span>
                            </div>
                          ) : hasBeenApproved ? (
                            <div style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '40px',
                              height: '40px',
                              background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                              borderRadius: '50%',
                              fontSize: '20px',
                              color: 'white',
                              fontWeight: 'bold',
                              boxShadow: '0 2px 8px rgba(40,167,69,0.3)'
                            }}>
                              ✓
                            </div>
                          ) : (
                            <span style={{ color: '#adb5bd', fontSize: '14px' }}>-</span>
                          )}
                        </td>
                        <td style={{ 
                          padding: '15px', 
                          textAlign: 'center'
                        }}>
                          {hasPending && canApprove ? (
                            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
                              <button
                                onClick={() => handleApprove(item._id)}
                                style={{
                                  padding: '10px 18px',
                                  background: 'linear-gradient(135deg, #28a745 0%, #218838 100%)',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                  fontSize: '14px',
                                  fontWeight: 'bold',
                                  boxShadow: '0 2px 8px rgba(40,167,69,0.3)',
                                  transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                              >
                                ✓ موافقة
                              </button>
                              <button
                                onClick={() => handleReject(item._id)}
                                style={{
                                  padding: '10px 18px',
                                  background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                  fontSize: '14px',
                                  fontWeight: 'bold',
                                  boxShadow: '0 2px 8px rgba(220,53,69,0.3)',
                                  transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                              >
                                ✕ رفض
                              </button>
                            </div>
                          ) : hasPending ? (
                            <span style={{ 
                              color: '#6c757d', 
                              fontSize: '14px',
                              fontStyle: 'italic'
                            }}>
                              في انتظار الموافقة
                            </span>
                          ) : (
                            <span style={{ color: '#adb5bd', fontSize: '14px' }}>-</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StationInventory;